export default __webpack_public_path__ + "static/media/mouse.402be070.svg";